export const leftColumnClassName = 'w-1/3 min-w-56 2xl:min-w-26 md:w-1/4';
export const rightColumnClassName = 'w-2/3 md:w-3/4';
